import { ICreateControleUseCase } from "../../../presentation/useCases/create/create_controle_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";


export class CreateControleUseCase implements ICreateControleUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async createControle( IdCentroCusto?: number | null, Descricao?: string | null): Promise<void> {
    
    await this.repository.createControle(
    IdCentroCusto, Descricao
    );
    
  }
}
